var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstructionEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92 92",
    style: {
      enableBackground: "new 0 0 92 92"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C6ECB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.3,34.7l5-5c5.2-5.2,5.2-13.8,0-19c-2.5-2.5-5.9-3.9-9.5-3.9c-3.6,0-7,1.4-9.5,3.9l-5,5L76.3,34.7z  M52.9,20.1L15.6,57.4c-0.8,0.8-1.4,1.8-1.8,2.8L6.9,81.2c-0.4,1.1-0.1,2.3,0.7,3.2c0.6,0.6,1.4,0.9,2.2,0.9c0.3,0,0.7-0.1,1-0.2 l20.9-6.9c1.1-0.4,2.1-1,2.8-1.8l37.3-37.3L52.9,20.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionEdit);
export default __webpack_public_path__ + "static/media/instruction-edit.160ef04001f312c6f3cb449d5481dabc.svg";
export { ForwardRef as ReactComponent };